import React, { useState } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { EMAIL_REGX } from "../../config/variables";
import { useDispatch } from "react-redux";
import { AuthAction } from "../../store/actions";

const Profile = ({ count, onChangeStep, user }) => {
  const dispatch = useDispatch();
  const [businessInfo, setBusinessInfo] = useState({
    address: "",
    business_name: "",
    email: "",
    employee_id_number: "",
    phone: "",
    zipcode: "",
  });
  const [errors, setErrors] = useState({
    addressError: "",
    business_nameError: "",
    emailError: "",
    employee_id_numberError: "",
    phoneError: "",
    zipcodeError: "",
  });
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );
  const onChangeHandle = (e) => {
    setBusinessInfo({
      ...businessInfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };
  const onSubmit = () => {
    const {
      address,
      business_name,
      email,
      employee_id_number,
      phone,
      zipcode,
    } = businessInfo;
    let addressError = "";
    let business_nameError = "";
    let emailError = "";
    let employee_id_numberError = "";
    let phoneError = "";
    let zipcodeError = "";
    if (
      !address.trim().length ||
      !business_name.trim().length ||
      !email.trim().length ||
      !employee_id_number.trim().length ||
      !phone.trim().length ||
      !zipcode.trim().length
    ) {
      if (!business_name.trim().length) {
        business_nameError = "Business Name is required.";
        setErrors({
          ...errors,
          business_nameError,
        });
      }
      if (!EMAIL_REGX.test(businessInfo.email)) {
        emailError = "Email is required.";
        setErrors({
          ...errors,
          business_nameError,
          emailError,
        });
      }
      if (!address.trim().length) {
        addressError = "Address is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
        });
      }
      if (!employee_id_number.trim().length) {
        employee_id_numberError = "Employe ID is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
        });
      }
      if (!phone.trim().length) {
        phoneError = "Phone is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
          phoneError,
        });
      }
      if (!zipcode.trim().length) {
        zipcodeError = "Zip Code is required.";
        setErrors({
          ...errors,
          business_nameError,
          addressError,
          emailError,
          employee_id_numberError,
          phoneError,
          zipcodeError,
        });
      }
      return;
    }
    dispatch(
      AuthAction.SignUp({ ...businessInfo, user }, () => onChangeStep())
    );
  };
  const {
    business_nameError,
    addressError,
    emailError,
    employee_id_numberError,
    phoneError,
    zipcodeError,
  } = errors;
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
          }}
        >
          <Steps current={count} progressDot={customDot}>
            <Step title="Register" />
            <Step title="Create Profile" />
            <Step title="Add your plant" />
            <Step title="Personlize" />
            <Step title="Build Catalog" />
            <Step title="Subscription" />
          </Steps>
          <Col className="login-card">
            <h2 className="text-left">Business Information</h2>
          </Col>
          <Row justify="center">
            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding"
            >
              <Row>
                <Col span={24}>
                  <TextInput
                    label={"Registered Business Name"}
                    name="business_name"
                    required
                    onChange={onChangeHandle}
                    value={businessInfo.business_name}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {business_nameError && business_nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Email Address "}
                    required
                    name={"email"}
                    onChange={onChangeHandle}
                    value={businessInfo.email}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {emailError && emailError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Address "}
                    required
                    name={"address"}
                    onChange={onChangeHandle}
                    value={businessInfo.address}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {addressError && addressError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding "
            >
              <Row>
                <Col span={24}>
                  <TextInput
                    label={"Employer Identification Number"}
                    required
                    name={"employee_id_number"}
                    onChange={onChangeHandle}
                    value={businessInfo.employee_id_number}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {employee_id_numberError && employee_id_numberError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Business Phone Number"}
                    required
                    name="phone"
                    onChange={onChangeHandle}
                    value={businessInfo.phone}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {phoneError && phoneError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Zip Code"}
                    required
                    name="zipcode"
                    onChange={onChangeHandle}
                    value={businessInfo.zipcode}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {zipcodeError && zipcodeError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Row justify="end">
          <Col xs={24} sm={24} md={10} lg={8} xl={6}>
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "50%",
                marginTop: "20px",
              }}
              onClick={() => onSubmit()}
            >
              ADD YOUR PLANT
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Profile;
